import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const TYRO_DEFAULT_INTERVAL = 2000;
const TYRO_DEFAULT_MAX_COUNT = 30;

const slice = createSlice({
  name: 'tyroPollingRules',
  initialState: {
    interval: TYRO_DEFAULT_INTERVAL, // Interval has to be in millisecond
    maxCount: TYRO_DEFAULT_MAX_COUNT,
  },
  reducers: {
    setTyroPollingRules(state, action: PayloadAction<TyroPollingRules>) {
      const { interval, maxCount } = action.payload;

      return {
        interval: (interval ?? TYRO_DEFAULT_INTERVAL / 1000) * 1000,
        maxCount: maxCount ?? TYRO_DEFAULT_MAX_COUNT,
      };
    },
  },
});

export const { setTyroPollingRules } = slice.actions;

export default slice.reducer;
